import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "swiper-wrapper" }
const _hoisted_2 = { class: "swiper-slide tag" }

import { ISectionsItem } from "@/models/models";
  import Swiper from "swiper";
  import { onMounted, PropType, ref } from "vue";
  import { RouterLink } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Tags',
  props: {
    data: {
      type: Object as PropType<Array<ISectionsItem>> | null,
      required: true,
    },
  },
  setup(__props) {

  const props = __props;

  const tags = ref(null as unknown as HTMLElement);

  onMounted(() => {
    if (tags.value) {
      new Swiper(tags.value, {
        slidesPerView: "auto",
        spaceBetween: 8,
      });
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tags swiper",
    ref_key: "tags",
    ref: tags
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(RouterLink), {
            to: `/catalog/${item.id}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 256))
    ])
  ], 512))
}
}

})